import { T } from '@/components/i18n/message.i18n.component';
import { Pill } from '@/components/ui/pill/pill.component';
import { ProductBuildingBlock } from '@/gql/graphql';
import { pretailoringPageMessages } from '@/pages/pre-tailoring/pre-tailoring.messages';
import { BuildingBlockDetailsRow } from '../details-building-block.component';

interface Props {
  bb: ProductBuildingBlock;
}

export const DesignObligationTab = ({ bb }: Props) => {
  return (
    <>
      <BuildingBlockDetailsRow
        context="design-obligation"
        label={<T {...pretailoringPageMessages.singleBuildingBlockDesignObligation} />}
        value={
          <Pill
            variant="do"
            data-testid="building-block-details-row-design-obligation-pill"
            text={bb.designObligation?.name}
          />
        }
      />
      <BuildingBlockDetailsRow
        context="design-obligation-description"
        label={<T {...pretailoringPageMessages.singleBuildingBlockDesignObligationDescription} />}
        value={bb.designObligation?.description}
      />
    </>
  );
};
